import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "security-ribbon"
}
const _hoisted_2 = { class: "security-ribbon__legend" }
const _hoisted_3 = { class: "security-ribbon__legend-message" }

import { computed, ref, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { type VerificationFlag } from '@exchange/libs/utils/launchdarkly/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityRibbon',
  props: {
  verification: { type: Object as PropType<VerificationFlag>, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const closed = ref(false);

const verificationReady = computed(() => props.verification.ready);
const ribbonData = computed(() => ({
  link: props.verification.link,
  text: verificationReady.value ? t('modules.ribbons.verify.text') : t('modules.ribbons.verify.textNotReady'),
  icon: {
    text: t('modules.ribbons.verify.button.text'),
    name: 'verify',
  },
}));

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (!closed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(ribbonData.value.text), 1),
          (verificationReady.value)
            ? (_openBlock(), _createBlock(_component_x_button, {
                key: 0,
                class: "legend__legend-button",
                size: "xs",
                variant: "primary",
                text: ribbonData.value.icon.text,
                "href-custom-icon": { name: ribbonData.value.icon.name },
                href: ribbonData.value.link
              }, null, 8, ["text", "href-custom-icon", "href"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "security-ribbon__close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closed.value = !closed.value))
        }, [
          _createVNode(_component_ot_icon, { name: "close" })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})